import React, { useState, useEffect } from 'react';
import { lang } from '../config/lang';
import QuoteRequest from '../components/QuoteRequest';
import PageContentService from '../services/pageContentService';
import { useInlineEdit } from '../components/admin/InlineEditContext';
import InlineEditableText from '../components/admin/InlineEditableText';

const Contact = () => {
  const { contact } = lang.fr;
  const inlineCtx = useInlineEdit && useInlineEdit();
  const [page, setPage] = useState(null);
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    phone: '',
    email: '',
    message: ''
  });
  const [showChatbot, setShowChatbot] = useState(false);

  const companyAddress = "123 Rue de la Rénovation, 75000 Paris, France";

  useEffect(() => {
    (async () => {
      try {
        const p = await PageContentService.getPage('contact');
        setPage(p);
      } catch (_) {
        setPage(null);
      }
    })();
  }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Message envoyé:', formData);
    // Ici vous pouvez ajouter la logique d'envoi
  };

  return (
    <div className="min-h-screen bg-gray-900 py-12">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          {(() => {
            const sections = Array.isArray(page?.sections) ? page.sections : [];
            const sec = sections.find(s => (s.key === 'header' || s.type === 'header')) || null;
            const t = sec?.data?.title?.fr || sec?.title || '';
            const d = sec?.data?.subtitle?.fr || '';
            return (
              <>
                <h1 className="text-3xl md:text-4xl font-bold mb-4 text-white">
                  {inlineCtx ? (
                    <InlineEditableText
                      value={inlineCtx.getValue('header', 'title.fr', t)}
                      sectionKey="header"
                      fieldPath="title.fr"
                      placeholder={''}
                    />
                  ) : (t || null)}
                </h1>
                <p className="text-gray-300 max-w-2xl mx-auto text-lg">
                  {inlineCtx ? (
                    <InlineEditableText
                      value={inlineCtx.getValue('header', 'subtitle.fr', d)}
                      sectionKey="header"
                      fieldPath="subtitle.fr"
                      placeholder={"Nous sommes là pour vous aider à réaliser votre projet de rénovation. Contactez-nous ou demandez un devis gratuit."}
                      multiline
                    />
                  ) : (d || null)}
                </p>
              </>
            );
          })()}
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mb-12">
          <div className="bg-gray-800 rounded-lg p-6">
            <h2 className="text-2xl font-semibold mb-6 text-white">
              {(() => {
                const sections = Array.isArray(page?.sections) ? page.sections : [];
                const sec = sections.find(s => (s.key === 'contact_info' || s.type === 'contact_info')) || null;
                const t = sec?.data?.title?.fr || sec?.title || '';
                return inlineCtx ? (
                  <InlineEditableText
                    value={inlineCtx.getValue('contact_info', 'title.fr', t)}
                    sectionKey="contact_info"
                    fieldPath="title.fr"
                    placeholder={''}
                  />
                ) : (t || null);
              })()}
            </h2>
            <div className="space-y-6">
              <div>
                <h3 className="text-lg font-medium mb-2 text-white">Adresse</h3>
                <p className="text-gray-300">
                  {(() => {
                    const sections = Array.isArray(page?.sections) ? page.sections : [];
                    const sec = sections.find(s => (s.key === 'contact_info' || s.type === 'contact_info')) || null;
                    const a = sec?.data?.address?.fr || '';
                    return inlineCtx ? (
                      <InlineEditableText
                        value={inlineCtx.getValue('contact_info', 'address.fr', a)}
                        sectionKey="contact_info"
                        fieldPath="address.fr"
                        placeholder={"123 Rue de la Rénovation, 75000 Paris, France"}
                        multiline
                      />
                    ) : (a || null);
                  })()}
                </p>
              </div>
              <div>
                <h3 className="text-lg font-medium mb-2 text-white">Téléphone</h3>
                <p className="text-gray-300">
                  {(() => {
                    const sections = Array.isArray(page?.sections) ? page.sections : [];
                    const sec = sections.find(s => (s.key === 'contact_info' || s.type === 'contact_info')) || null;
                    const ph = sec?.data?.phone || '';
                    return inlineCtx ? (
                      <InlineEditableText
                        value={inlineCtx.getValue('contact_info', 'phone', ph)}
                        sectionKey="contact_info"
                        fieldPath="phone"
                        placeholder={"+33 1 23 45 67 89"}
                      />
                    ) : (ph || null);
                  })()}
                </p>
              </div>
              <div>
                <h3 className="text-lg font-medium mb-2 text-white">Email</h3>
                <p className="text-gray-300">
                  {(() => {
                    const sections = Array.isArray(page?.sections) ? page.sections : [];
                    const sec = sections.find(s => (s.key === 'contact_info' || s.type === 'contact_info')) || null;
                    const em = sec?.data?.email || '';
                    return inlineCtx ? (
                      <InlineEditableText
                        value={inlineCtx.getValue('contact_info', 'email', em)}
                        sectionKey="contact_info"
                        fieldPath="email"
                        placeholder={"contact@2renov.fr"}
                      />
                    ) : (em || null);
                  })()}
                </p>
              </div>
              <div>
                <h3 className="text-lg font-medium mb-2 text-white">Horaires</h3>
                <p className="text-gray-300">
                  {(() => {
                    const sections = Array.isArray(page?.sections) ? page.sections : [];
                    const sec = sections.find(s => (s.key === 'contact_info' || s.type === 'contact_info')) || null;
                    const sch = sec?.data?.schedule?.fr || '';
                    return inlineCtx ? (
                      <InlineEditableText
                        value={inlineCtx.getValue('contact_info', 'schedule.fr', sch)}
                        sectionKey="contact_info"
                        fieldPath="schedule.fr"
                        placeholder={"Lundi - Vendredi: 9h - 18h\nSamedi - Dimanche: 9h - 20h"}
                        multiline
                      />
                    ) : (sch || null);
                  })()}
                </p>
              </div>
            </div>

            {/* Map de l'entreprise */}
            <div className="mt-6">
              <h3 className="text-lg font-medium mb-4 text-white">Notre localisation</h3>
              <div className="relative h-[300px] rounded-lg overflow-hidden border border-gray-600">
                <iframe
                  src={`https://www.google.com/maps?q=${encodeURIComponent(companyAddress)}&output=embed`}
                  width="100%"
                  height="100%"
                  style={{ border: 0 }}
                  allowFullScreen=""
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                />
              </div>
            </div>
          </div>

          <div className="bg-gray-800 rounded-lg p-6">
            <h2 className="text-2xl font-semibold mb-6 text-white">
              {(() => {
                const sections = Array.isArray(page?.sections) ? page.sections : [];
                const sec = sections.find(s => (s.key === 'quick_message' || s.type === 'quick_message')) || null;
                const t = sec?.data?.title?.fr || sec?.title || '';
                return inlineCtx ? (
                  <InlineEditableText
                    value={inlineCtx.getValue('quick_message', 'title.fr', t)}
                    sectionKey="quick_message"
                    fieldPath="title.fr"
                    placeholder={''}
                  />
                ) : (t || null);
              })()}
            </h2>
            <form onSubmit={handleSubmit} className="space-y-6">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                  <label htmlFor="firstName" className="block text-gray-300 mb-2">
                    Prénom *
                  </label>
                  <input
                    type="text"
                    id="firstName"
                    name="firstName"
                    value={formData.firstName}
                    onChange={handleInputChange}
                    className="w-full bg-gray-700 text-white rounded-lg p-3 focus:ring-2 focus:ring-primary"
                    required
                  />
                </div>
                <div>
                  <label htmlFor="lastName" className="block text-gray-300 mb-2">
                    Nom *
                  </label>
                  <input
                    type="text"
                    id="lastName"
                    name="lastName"
                    value={formData.lastName}
                    onChange={handleInputChange}
                    className="w-full bg-gray-700 text-white rounded-lg p-3 focus:ring-2 focus:ring-primary"
                    required
                  />
                </div>
              </div>

              <div>
                <label htmlFor="phone" className="block text-gray-300 mb-2">
                  Numéro de téléphone *
                </label>
                <input
                  type="tel"
                  id="phone"
                  name="phone"
                  value={formData.phone}
                  onChange={handleInputChange}
                  placeholder="06 12 34 56 78"
                  className="w-full bg-gray-700 text-white rounded-lg p-3 focus:ring-2 focus:ring-primary"
                  required
                />
              </div>

              <div>
                <label htmlFor="email" className="block text-gray-300 mb-2">
                  Email *
                </label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleInputChange}
                  className="w-full bg-gray-700 text-white rounded-lg p-3 focus:ring-2 focus:ring-primary"
                  required
                />
              </div>

              <div>
                <label htmlFor="message" className="block text-gray-300 mb-2">
                  Message *
                </label>
                <textarea
                  id="message"
                  name="message"
                  value={formData.message}
                  onChange={handleInputChange}
                  rows="4"
                  className="w-full bg-gray-700 text-white rounded-lg p-3 focus:ring-2 focus:ring-primary"
                  required
                ></textarea>
              </div>

              <button 
                type="submit" 
                className="w-full bg-primary text-white py-3 rounded-lg hover:bg-primary/90 transition-colors font-semibold"
              >
                Envoyer le message
              </button>
            </form>
          </div>
        </div>

        <div className="bg-gray-800 rounded-lg p-6">
          <QuoteRequest />
        </div>
      </div>

      {/* Bouton IA flottant */}
      <button
        onClick={() => setShowChatbot(!showChatbot)}
        className="fixed bottom-16 right-6 bg-primary hover:bg-primary/90 text-white w-16 h-16 rounded-full shadow-lg transition-all transform hover:scale-110 z-50 flex flex-col items-center justify-center"
      >
        <svg className="w-7 h-7 mb-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z" />
        </svg>
        <span className="text-xs font-semibold">IA</span>
      </button>

      {/* Chatbot */}
      {showChatbot && (
        <div className="fixed bottom-36 right-2 w-80 h-96 bg-gray-800 rounded-lg shadow-xl z-50 flex flex-col">
          <div className="bg-primary text-white p-4 rounded-t-lg flex justify-between items-center">
            <h3 className="font-semibold">Assistant IA 2RENOV</h3>
            <button 
              onClick={() => setShowChatbot(false)}
              className="text-white hover:bg-primary/80 rounded p-1"
            >
              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>
          <div className="flex-1 p-4 bg-gray-700 overflow-y-auto">
            <div className="bg-gray-600 rounded-lg p-3 mb-3">
              <p className="text-white text-sm">
                Bonjour ! Je suis votre assistant IA. Comment puis-je vous aider avec votre projet de rénovation ?
              </p>
            </div>
            <div className="text-center text-gray-400 text-sm">
              Fonctionnalité à venir...
            </div>
          </div>
          <div className="p-4 bg-gray-800 rounded-b-lg">
            <div className="flex">
              <input 
                type="text" 
                placeholder="Tapez votre message..."
                className="flex-1 bg-gray-700 text-white rounded-l-lg px-3 py-2 text-sm focus:outline-none"
                disabled
              />
              <button className="bg-primary text-white px-4 py-2 rounded-r-lg">
                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 19l9 2-9-18-9 18 9-2zm0 0v-8" />
                </svg>
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Contact; 
